import ExamSectionTemplate from '@/pages/ExamSectionTemplate';

const faqs = [
  {
    question: "What is CBEAM certification?",
    answer: "CBEAM (Competency-Based Examination in Aesthetic Medicine) is IMCAC's flagship certification for licensed healthcare professionals practising clinical aesthetic medicine. It validates competency across facial anatomy, injectable treatments, energy devices, and complication management."
  },
  {
    question: "Who is eligible to apply for CBEAM?",
    answer: "Eligible candidates must hold valid medical or dental registration, have minimum 2 years post-licensure clinical experience, provide evidence of relevant aesthetic medicine training or practice, and maintain current professional indemnity insurance."
  },
  {
    question: "What does the CBEAM examination include?",
    answer: "CBEAM consists of four stages: Written Examination (MCQ-based), OSCE with 10-12 clinical stations, verified Case Log submission demonstrating procedural experience, and Viva/Case Defense testing clinical reasoning and complication management skills."
  },
  {
    question: "How long is CBEAM certification valid?",
    answer: "Initial CBEAM certification is valid for 5 years from the date of issue. Recertification requires maintaining minimum 25 CPD hours annually, evidence of continued clinical practice, and compliance audit by the IMCAC CPD Committee."
  },
  {
    question: "What procedures are covered in CBEAM assessment?",
    answer: "CBEAM covers botulinum toxin applications, dermal fillers, laser and energy-based devices, chemical peels, mesotherapy, thread lifting, and complication management including vascular occlusion protocols and emergency response procedures."
  },
  {
    question: "Does CBEAM certification allow me to practice aesthetic medicine?",
    answer: "CBEAM validates assessed competencies but does not grant medical licensure. You must hold valid professional registration in your jurisdiction. CBEAM certification demonstrates competency and may support credentialing but is not a substitute for local licensing requirements."
  }
];

export default function AestheticMedicinePage() {
  return (
    <ExamSectionTemplate
      sectionTitle="Section 1: Aesthetic Medicine"
      examCode="CBEAM"
      ipcfBadge="Level 6 Practitioner Certification"
      examFullName="Competency-Based Examination in Aesthetic Medicine"
      testIdPrefix="cbeam"
      fee="₹39,000"
      faqs={faqs}
      overview="CBEAM is IMCAC's flagship competency-based examination for licensed healthcare professionals practising clinical aesthetic medicine. The examination assesses clinical knowledge, procedural competence, complication management, and ethical practice through a rigorous multi-stage assessment framework."
      eligibility={[
        'Valid medical or dental registration in home jurisdiction',
        'Minimum 2 years post-licensure clinical experience',
        'Evidence of relevant training or practice in aesthetic medicine',
        'Professional references from two registered medical practitioners',
        'Compliance with IMCAC ethics and conduct standards',
        'Current professional indemnity insurance',
      ]}
      stages={[
        { title: 'Written Examination', desc: 'Comprehensive MCQ-based assessment covering all core domains of aesthetic medicine practice.' },
        { title: 'OSCE (10-12 Stations)', desc: 'Objective Structured Clinical Examination with standardised clinical and procedural stations.' },
        { title: 'Case Log Submission', desc: 'Verified clinical case log demonstrating breadth and depth of procedural experience.' },
        { title: 'Viva & Case Defense', desc: 'Oral examination testing clinical reasoning, decision-making, and complication management.' },
      ]}
      coreDomains={[
        'Facial Anatomy',
        'Botulinum Toxin & Fillers',
        'Laser & Energy-Based Devices',
        'Complication Management',
        'Emergency Protocols',
        'Ethics & Consent',
      ]}
      certificationValidity={[
        'Initial certification valid for 5 years from date of issue',
        'Certificate verifiable through IMCAC public verification portal',
        'Certification title: Board Certified in Aesthetic Medicine (IMCAC – CBEAM)',
        'Certification may be revoked for non-compliance with CPD or ethics requirements',
      ]}
      recertificationPolicy={[
        'Recertification required every 5 years',
        'Minimum 25 CPD hours per year in relevant activities',
        'Evidence of continued clinical practice',
        'Compliance audit by IMCAC CPD Committee',
        'Non-compliance may result in suspension of certification status',
      ]}
      disclaimer="Certification validates assessed competencies within aesthetic medicine and does not grant medical licensure. Candidates must hold valid professional registration in their jurisdiction. IMCAC does not function as a university and does not grant degrees."
      applyLink="/apply"
    />
  );
}
